export default [
    {
        path: '/payment-events',
        name: 'payment-events',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Eventos de Pagamento',
            icon: 'mdi-cash-register',
            breadcrumbs: [
                { text: 'Lista de Eventos de Pagamento', disabled: true }
            ]
        }
    }
]